import settings from '@/settings'

let get = (headers) => {
  return fetch(`${settings.apetrusApi}/tipospagamento/`, {
    method: 'GET',
    mode: 'cors',
    headers: headers
  })
}

const permitirTipoPagamentoPosPago = (posto, referencia, headers) => {
  return fetch(`${settings.apetrusApi}/tipospagamento/receberpospago/?posto=${posto}&tipo=${referencia}`, {
    method: 'PUT',
    mode: 'cors',
    headers: headers
  })
}

export default {
  get,
  permitirTipoPagamentoPosPago
}
